function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExample0Overlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 210,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,41.7C253.3,41.7 256.6,41.8 259.8,42L259.8,12L240,12L240,42C243.4,41.8 246.7,41.7 250,41.7Z",
    style: {
      fill: "rgb(51,51,51)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,26.3L250,21.8L244,26.3L250,38.9L256,26.3Z",
    style: {
      fill: "rgb(240,70,34)",
      fillRule: "nonzero",
      stroke: "rgb(240,70,34)",
      strokeWidth: "0.5px",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample0Overlay);
export default __webpack_public_path__ + "static/media/example-0-overlay.5104e0664a84653f5f10b4e5c1de6824.svg";
export { ForwardRef as ReactComponent };